import { render } from "./RecentProducts.vue?vue&type=template&id=54e8a18a"
import script from "./RecentProducts.vue?vue&type=script&lang=js"
export * from "./RecentProducts.vue?vue&type=script&lang=js"

import "./RecentProducts.vue?vue&type=style&index=0&id=54e8a18a&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__